'use client';

import type { ComponentType, ReactNode } from 'react';
import { ActiveAfterEffectsEntitiesProvider } from '../aftereffects/contexts/ActiveAfterEffectsEntitiesContext';
import { ActivePremiereEntitiesProvider } from '../premiere/contexts/ActivePremiereEntitiesContext';
import type { IntegrationHostMap } from '../shared/utils/integrationHostMap';

type HostEntitiesProviderProps = { children: ReactNode };

export type HostEntitiesProviderComponent =
  ComponentType<HostEntitiesProviderProps>;

export const HOST_ENTITIES_PROVIDERS = {
  premiere: ActivePremiereEntitiesProvider,
  aftereffects: ActiveAfterEffectsEntitiesProvider,
} satisfies IntegrationHostMap<HostEntitiesProviderComponent | null>;
